import { Route, AppId, createPageRoute } from '@lumapps/router';

export const learningAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/learning/:tab?',
    id: 'learning-analytics',
    appId: AppId.backOffice,
});

export const learningAnalytics = (tab?: string): Route => {
    return {
        ...learningAnalyticsRoute,
        params: tab
            ? {
                  tab,
              }
            : undefined,
    };
};
